export const FETCH_SUMMARY_TRUCK_INIT = 'FETCH_SUMMARY_TRUCK_INIT';
export const FETCH_SUMMARY_TRUCK_SUCCESS = 'FETCH_SUMMARY_TRUCK_SUCCESS';
export const FETCH_SUMMARY_TRUCK_FAILURE = 'FETCH_SUMMARY_TRUCK_FAILURE';

export const FETCH_SUMMARY_TRUCK_COUNT_INIT = 'FETCH_SUMMARY_TRUCK_COUNT_INIT';
export const FETCH_SUMMARY_TRUCK_COUNT_SUCCESS = 'FETCH_SUMMARY_TRUCK_COUNT_SUCCESS';
export const FETCH_SUMMARY_TRUCK_COUNT_FAILURE = 'FETCH_SUMMARY_TRUCK_COUNT_FAILURE';

export const FETCH_SUMMARY_TRUCK_NO_LOADING_INIT = 'FETCH_SUMMARY_TRUCK_NO_LOADING_INIT';
export const FETCH_SUMMARY_TRUCK_NO_LOADING_SUCCESS = 'FETCH_SUMMARY_TRUCK_NO_LOADING_SUCCESS';
export const FETCH_SUMMARY_TRUCK_NO_LOADING_FAILURE = 'FETCH_SUMMARY_TRUCK_NO_LOADING_FAILURE';

export const SET_FILTER_SUMMARY_TRUCK = 'SET_FILTER_SUMMARY_TRUCK';
export const RESET_SUMMARY_TRUCK = 'RESET_SUMMARY_TRUCK';



// WEBPACK FOOTER //
// ./source/client/actions/summary_truck/types.js